export const createGoogleMapsLink = (address: string): string => {
  return `https://www.google.com/maps/search/${encodeURIComponent(address)}`
}

export const createPhoneLink = (phone: string): string => {
  return `tel:${phone}`
}
